import React, {useEffect} from 'react';
import {Form, Input, Modal, Select, message} from 'antd';
import {useMutation} from '@apollo/client';
import {CONFIRM_BCP_CHECK_RESULT} from '../graphql/mutations/bcpCheckResultMutations';
import {CONFIRM_CODE_OPTIONS} from '../utils/confirmCodeOptions';

interface BcpCheckResultConfirmModalProps {
    visible: boolean;
    resultId?: number;
    onSuccess: () => void;
    onCancel: () => void;
}

const BcpCheckResultConfirmModal: React.FC<BcpCheckResultConfirmModalProps> = ({
    visible,
    resultId,
    onSuccess,
    onCancel,
}) => {
    const [form] = Form.useForm();
    const [confirmResult, {loading}] = useMutation(CONFIRM_BCP_CHECK_RESULT);

    useEffect(() => {
        if (visible) form.resetFields();
    }, [visible, form]);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            const res = await confirmResult({
                variables: {
                    id: resultId,
                    input: {confirmCode: values.confirmCode, confirmDesc: values.confirmDesc},
                },
            });
            const result = res.data?.confirmBcpCheckResult;
            if (!result?.success) {
                message.error(result?.message || '确认失败');
                return;
            }
            message.success('确认成功');
            onSuccess();
        } catch (e: any) {
            message.error(e?.message || '确认失败');
        }
    };

    return (
        <Modal
            title="确认差错处理结果"
            open={visible}
            onOk={handleOk}
            onCancel={onCancel}
            confirmLoading={loading}
            okText="确认"
            cancelText="取消"
            width={480}
            destroyOnClose
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    label="确认码"
                    name="confirmCode"
                    rules={[{required: true, message: '请选择确认码'}]}
                >
                    <Select placeholder="请选择确认码">
                        {CONFIRM_CODE_OPTIONS.map(o => (
                            <Select.Option key={o.value} value={o.value}>{o.label}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    label="确认描述"
                    name="confirmDesc"
                    rules={[{required: true, message: '请输入确认描述'}]}
                >
                    <Input.TextArea rows={3} placeholder="请输入确认描述" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default BcpCheckResultConfirmModal;
